/** Tiny change notifier so screens can reload when the store or the sync state changes. */
export type Topic = "booths" | "sections" | "drafts" | "outbox" | "kv" | "state";
export type Listener = (topic: Topic) => void;

export class Emitter {
  private listeners = new Set<Listener>();

  subscribe(fn: Listener): () => void {
    this.listeners.add(fn);
    return () => {
      this.listeners.delete(fn);
    };
  }

  emit(topic: Topic = "state"): void {
    for (const fn of [...this.listeners]) {
      try {
        fn(topic);
      } catch {
        // a broken listener must never break a save
      }
    }
  }
}
